<div class="inspection-list">
    <ng-container *ngIf="visibleInspections.length > 0; else noInspections">
        <app-inspection-item
                *ngFor="let inspection of visibleInspections; let i = index"
                [inspection]="inspection"
                [index]="i"
                (edit)="onEditInspection($event)"
        >
        </app-inspection-item>

        <div *ngIf="hasMoreInspections" class="show-more-container">
            <button
                    mat-button
                    class="show-more-button"
                    (click)="showMore()">
                {{ 'pages.inspectionList.show_more' | translate }}
                <mat-icon>expand_more</mat-icon>
            </button>
        </div>
    </ng-container>

    <ng-template #noInspections>
        <div class="no-inspections">
            {{ 'pages.inspectionList.no_inspections_found' | translate }}
        </div>
    </ng-template>
</div>
